import React, { useState } from "react";
import { Table, Tag, Button, Modal, Descriptions, Space, Tooltip } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const PurifierDetailsTable = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedPurifier, setSelectedPurifier] = useState(null);

  const showModal = (record) => {
    setSelectedPurifier(record);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setSelectedPurifier(null);
  };

  const columns = [
    {
      title: "Purifier Name",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Purifier Maker",
      dataIndex: "purifier_make",
      key: "purifier_make",
    },
    {
      title: "Purifier Model",
      dataIndex: "purifie_model",
      key: "purifie_model",
    },
    {
      title: "Selected Parameters",
      dataIndex: "selected_parameters",
      key: "selected_parameters",
      width: "50%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((param, index) => (
              <Tag color="blue" key={index}>
                {param}
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },

    {
      title: "Other Parameters",
      dataIndex: "other_parameters",
      key: "other_parameters",
      width: "20%",
      render: (params) =>
        params && params.length > 0 ? (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
            {params.map((item, index) => (
              <Tag color="green" key={index}>
                {item.name} ({item.unit})
              </Tag>
            ))}
          </div>
        ) : (
          <span>—</span>
        ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Details">
            <Button
              type="primary"
              icon={<EyeOutlined />}
              onClick={() => showModal(record)}
              size="small"
            >
              View
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        pagination={{ pageSize: 5 }}
        bordered
        className="custom-table"
      />

      <Modal
        title="Purifier Details"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={700}
      >
        {selectedPurifier && (
          <Descriptions bordered column={1} size="small">
            <Descriptions.Item label="Purifier Name">{selectedPurifier.title}</Descriptions.Item>
            <Descriptions.Item label="Maker">{selectedPurifier.purifier_make}</Descriptions.Item>
            <Descriptions.Item label="Model">{selectedPurifier.purifie_model}</Descriptions.Item>
            <Descriptions.Item label="Selected Parameters">
              {Array.isArray(selectedPurifier.selected_parameters) &&
              selectedPurifier.selected_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedPurifier.selected_parameters.map((param, index) => (
                    <Tag color="blue" key={index}>
                      {param}
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Other Parameters">
              {Array.isArray(selectedPurifier.other_parameters) &&
              selectedPurifier.other_parameters.length > 0 ? (
                <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                  {selectedPurifier.other_parameters.map((item, index) => (
                    <Tag color="green" key={index}>
                      {item.name} ({item.unit})
                    </Tag>
                  ))}
                </div>
              ) : (
                "—"
              )}
            </Descriptions.Item>
          </Descriptions>
        )}
      </Modal>
    </>
  );
};

export default PurifierDetailsTable;
